/* tslint:disable */
import {
  GameEmoji,
  GamePlayerEmoji
} from '../index';

declare var Object: any;
export interface EmojiInterface {
  "image"?: string;
  "emojiType"?: string;
  "isActive": boolean;
  "order": number;
  "isCompressed": boolean;
  "id"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  games?: GameEmoji[];
  emojiPlayers?: GamePlayerEmoji[];
}

export class Emoji implements EmojiInterface {
  "image": string;
  "emojiType": string;
  "isActive": boolean;
  "order": number;
  "isCompressed": boolean;
  "id": any;
  "createdAt": Date;
  "updatedAt": Date;
  games: GameEmoji[];
  emojiPlayers: GamePlayerEmoji[];
  constructor(data?: EmojiInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Emoji`.
   */
  public static getModelName() {
    return "Emoji";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Emoji for dynamic purposes.
  **/
  public static factory(data: EmojiInterface): Emoji{
    return new Emoji(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Emoji',
      plural: 'emojis',
      path: 'emojis',
      idName: 'id',
      properties: {
        "image": {
          name: 'image',
          type: 'string'
        },
        "emojiType": {
          name: 'emojiType',
          type: 'string',
          default: 'regular'
        },
        "isActive": {
          name: 'isActive',
          type: 'boolean',
          default: true
        },
        "order": {
          name: 'order',
          type: 'number',
          default: -1
        },
        "isCompressed": {
          name: 'isCompressed',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        games: {
          name: 'games',
          type: 'GameEmoji[]',
          model: 'GameEmoji',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'emojiId'
        },
        emojiPlayers: {
          name: 'emojiPlayers',
          type: 'GamePlayerEmoji[]',
          model: 'GamePlayerEmoji',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'emojiId'
        },
      }
    }
  }
}
